import { useMapContext, type MapV2Props } from 'components/MapV2/MapProvider'
import React, { useEffect, useState } from 'react'
import { useMap } from 'react-leaflet'
import { LatLngTuple } from 'leaflet'

type BoundControlProps = { isActive?: MapV2Props['shouldFitBoundsToMarkers'] }

export const BoundControl: React.FC<BoundControlProps> = ({ isActive }) => {
  const { markers, polygons, parsedKmls } = useMapContext()
  const map = useMap()

  const [isBoundsSet, setIsBoundsSet] = useState(false)

  useEffect(() => {
    if ((markers || polygons) && isActive && !isBoundsSet) {
      try {
        const bounds = [
          ...((markers?.map((marker) => marker.marker.position) as LatLngTuple[]) ?? []),
          ...((polygons?.map((polygon) => polygon.positions) as any) ?? []),
          ...(parsedKmls?.map((kml) => kml.positions) ?? []),
        ]
        const zoomLevel = map.getZoom()
        map.fitBounds(bounds, {
          padding: [60, 60],
          maxZoom: zoomLevel,
        })
        isActive === 'once' && setIsBoundsSet(true)
      } catch (error) {
        console.error({ error })
      }
    }
  }, [markers, isActive, polygons, parsedKmls])

  return null
}
